export default "__VITE_ASSET__6facd438__"